module.exports = __webpack_public_path__ + "img/alu-guide-top.3f781bcc.svg";